import { useEffect, useState } from "react";
import "./style.scss";
import { userAuthRequests } from "@/src/api/userInfoRequests";
import { IUserData } from "@/src/types/userAuthTypes";
import VerticalLine from "@/src/components/VerticalLine/VerticalLine";

const UPList = () => {
  const [users, setUsers] = useState<IUserData[]>([]);

  const getUsersList = async () => {
    try {
      const usersList = await userAuthRequests.usersList();
      console.log("usersList", usersList);

      if (usersList && Array.isArray(usersList)) {
        setUsers(usersList);
      } else {
        console.log("Ошибка запроса: ответ пустой");
      }
    } catch (error) {
      console.error("Ошибка при получении списка пользователей:", error);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  // Если пользователей нет
  if (users.length === 0) {
    return (
      <div className="container user-page">
        <p>Загрузка списка пользователей...</p>
      </div>
    );
  }

  // Ключи для таблицы
  const headers = Object.keys(users[0]) as (keyof IUserData)[];

  // Словарь для "человеческих" заголовков
  const headerLabels: Record<keyof IUserData, string> = {
    login: "Login",
    password: "Password",
    role: "Role",
    email: "Email",
    access_token: "Access Token",
    config: "Config",
    user_id: "ID",
    firstname: "First Name",
    lastname: "Last Name",
    id: "ID",
  };

  return (
    <div className="user-page-list">
      <p className="user-page-list-title">Users:</p>
      <div className="user-page-list-table-wrapper">
        <table className="user-page-list-table">
          <thead>
            <tr>
              {headers.map((key) => (
                <th key={key}>
                  <div className="cell-wrapper">
                    {headerLabels[key] ?? key}
                    <div className="vertical-line">
                      <VerticalLine />
                    </div>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr key={index}>
                {headers.map((key) => (
                  <td key={key}>
                    <div className="cell-wrapper">
                      {user[key] === null || user[key] === undefined
                        ? "-"
                        : typeof user[key] === "object"
                        ? JSON.stringify(user[key])
                        : String(user[key])}
                      <div className="vertical-line">
                        <VerticalLine />
                      </div>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UPList;
